import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { NgModule } from '@angular/core';
import { DndModule } from 'ngx-drag-drop';
import { AppComponent } from './app.component';
import { CoreModule } from '@app/core/core.module';
import { HttpRequestInterceptorModule } from './shared/interceptors/http-request.interceptor.module';
import { ConfirmationService } from 'primeng/api';
import { AppRoutingModule } from './app-routing.module';
import { DynamicDialogModule } from 'primeng/components/dynamicdialog/dynamicdialog';
import {NgxMaskModule} from 'ngx-mask';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    FormsModule,
    AppRoutingModule,
    HttpRequestInterceptorModule,
    HttpClientModule,
    DndModule,
    NgxMaskModule.forRoot({
      showMaskTyped : true,
    }),
    ReactiveFormsModule,
    DynamicDialogModule,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS
    },
    JwtHelperService,
    ConfirmationService
  ]
})
export class AppModule { }
